import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { useTranslation } from "react-i18next";
import { changeDateRange } from "../searchFlightsSlice";

function DateRangeInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const dateRange = useAppSelector(
    (state) => state.searchFlights.form.dateRange
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);

  const onChange = () => dispatch(changeDateRange(!dateRange));

  return (
    <div className="field">
      <div className="control">
        <label className="checkbox" title={t("PLUS_MINUS_3_DAYS_SEARCH_TITLE")}>
          <input
            type="checkbox"
            checked={dateRange}
            disabled={disabled}
            onChange={onChange}
          />
          {t("CHECKBOX_DATERANGE")}
        </label>
      </div>
    </div>
  );
}

export default DateRangeInput;
